<div class="container">

  <app-header-dialog [iconName]="'noise_control_off'">
    Carrossel
  </app-header-dialog>

  <div *ngIf="entityForm">

    <div class="content">

      <mat-form-field class="category-width" appearance="outline">

        <mat-label>Local</mat-label>
        <mat-select [errorStateMatcher]="matcher" [formControl]="entityForm.controls.location">
          <mat-option *ngFor="let location of locations" [value]="location">
            {{ location }}
          </mat-option>
        </mat-select>

      </mat-form-field>



      <mat-form-field style='width: 80px; margin-left: 20px;' appearance="outline">
        <mat-label>Posição</mat-label>
        <input matInput type="number" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.position"
          autocomplete="off">
      </mat-form-field>

      <mat-form-field style='width: 180px; margin-left: 20px;' appearance="outline">
        <mat-label>Data Entrada</mat-label>
        <input matInput [matDatepicker]="pickerIn" [errorStateMatcher]="matcher"
          [formControl]="entityForm.controls.dateIn">
        <mat-datepicker-toggle matSuffix [for]="pickerIn"></mat-datepicker-toggle>
        <mat-datepicker #pickerIn></mat-datepicker>
      </mat-form-field>

      <mat-form-field style='width: 180px; margin-left: 20px;' appearance="outline">
        <mat-label>Data Saída</mat-label>
        <input matInput [matDatepicker]="pickerOut" [errorStateMatcher]="matcher"
          [formControl]="entityForm.controls.dateOut">
        <mat-datepicker-toggle matSuffix [for]="pickerOut"></mat-datepicker-toggle>
        <mat-datepicker #pickerOut></mat-datepicker>
      </mat-form-field>

      <div>
        <mat-form-field style='width: 180px; margin-right:20px;' appearance="outline">
          <mat-label>Chave</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.key"
            autocomplete="off">
        </mat-form-field>

        <mat-form-field style='width: 500px;' appearance="outline">
          <mat-label>Link</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.link"
            autocomplete="off">
        </mat-form-field>
      </div>

      <div>

        <div>
          <input type="file" #fileImage (change)="onFileSelectedBig($event)" accept="image/*, application/pdf"
            style="display:none;">
          <a mat-raised-button (click)='fileImage.click()' matTooltip='Selecionar arquivo'
            style='background-color: whitesmoke; margin: 10px;'>
            <mat-icon class='icon-add'>image_search</mat-icon>
            Arquivo Desktop
          </a>

          <div style="margin: 10px;" *ngIf="selectedFileNameBig">{{selectedFileNameBig}}</div>

        </div>

        <div style="display: flex; justify-content: center; width: 100%;">
          <img [src]="storedImageBig" style="height: 350px; " *ngIf="storedImageBig">
        </div>

      </div>

      <div>

        <div>
          <input type="file" #fileImageSmall (change)="onFileSelectedSmall($event)" accept="image/*, application/pdf"
            style="display:none;">
          <a mat-raised-button (click)='fileImageSmall.click()' matTooltip='Selecionar arquivo'
            style='background-color: whitesmoke; margin: 30px 10px 10px 10px;'>
            <mat-icon class='icon-add'>image_search</mat-icon>
            Arquivo Mobile
          </a>

          <div style="margin: 10px;" *ngIf="selectedFileNameSmall">{{selectedFileNameSmall}}</div>

        </div>

        <div style="display: flex; justify-content: center; width: 100%;">
          <img [src]="storedImageSmall" style="height: 350px; " *ngIf="storedImageSmall">
        </div>

      </div>

    </div>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
      <button *ngIf="!isEdit" matTooltip='Inserir' mat-raised-button
        (click)="matDialogRef.close(['insert', entityForm, selectedFileBig, selectedFileSmall])"
        [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>
      <button *ngIf="isEdit" matTooltip='Alterar' mat-raised-button
        (click)="matDialogRef.close(['update', entityForm, selectedFileBig, selectedFileSmall])"
        [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>

    </div>

  </div>

</div>